import React, { useContext } from 'react'
import { Box } from '@hub/box'
import { DEFAULT_BREAKPOINT, useBreakpointValue } from '@hub/design-system-base'
import useMobileBreakpoint from '@scentregroup/shared/helpers/use-mobile-breakpoint'
import { LinkContext } from '../../../context'
import { LinkItem, OpenHamburgerMenuAtPathType } from '../types'
import { MegaMenuNavItem } from './megamenu-nav-link'
import { MainNavItemWrapper } from './main-nav-item-wrapper'

interface NavLinkProps {
  item: LinkItem
  index: number
  openHamburgerMenuAtPath: OpenHamburgerMenuAtPathType
  megaMenuPortalRef?: React.RefObject<HTMLElement | null>
  openId: string
  setOpenId: (id: string) => void
}

export const NavLink: React.FC<NavLinkProps> = ({
  item,
  index,
  openHamburgerMenuAtPath,
  megaMenuPortalRef,
  openId,
  setOpenId,
}) => {
  const attrsWhitelist = ['target', 'rel', 'title']
  const attrs = item.attrs
  const Link = useContext(LinkContext)
  // check if mobile view
  const isMobile = useMobileBreakpoint()
  const isWide = useBreakpointValue([false, false, true], DEFAULT_BREAKPOINT)

  if (isWide && (item.megaMenuItems || item.simpleMenuItems)) {
    return (
      <MegaMenuNavItem
        index={index}
        item={item}
        megaMenuPortalRef={megaMenuPortalRef}
        openId={openId}
        setOpenId={setOpenId}
      />
    )
  } else if (
    (isMobile && item.hamburgerMenuTarget) ||
    (!item.url && item.hamburgerMenuTarget)
  ) {
    return (
      <MainNavItemWrapper isDisplayedHorizontally>
        <Box
          as="button"
          sx={{ height: 'size-full' }}
          onClick={() => openHamburgerMenuAtPath(item.hamburgerMenuTarget)}
        >
          {item.label}
        </Box>
      </MainNavItemWrapper>
    )
  } else if (item.url) {
    return (
      <MainNavItemWrapper isDisplayedHorizontally>
        <Box
          as={props => <Link {...props} />}
          to={item.url}
          {...(attrs &&
            attrsWhitelist.reduce(
              (memo, key) => ({ ...memo, [key]: attrs[key] }),
              {}
            ))}
          sx={{
            height: 'size-full',
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          {item.label}
        </Box>
      </MainNavItemWrapper>
    )
  }
  // If no mega menu items, no hamburger targets, and no url... Don't
  // render anything
  return null
}
